import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const API = () => <PublicStaticPage pageKey="api" />;

export default API;
